import React from 'react';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {TrialModalContext} from 'app/demo/components/StartTrialModal';
import {gt} from 'app/utils/i18n';

interface Props {
  title?: string;
  className?: string;
  activeClassName?: string;
  html_url: string;
  children: React.ReactNode;
  renderRegularLink?: boolean;
  onClick?: (e: React.MouseEvent) => any;
}

export function DemoFullHTMLLink({
  /* eslint-disable @typescript-eslint/no-unused-vars */
  html_url,
  activeClassName,
  renderRegularLink,
  /* eslint-enable @typescript-eslint/no-unused-vars */
  children,
  ...other
}: Props): JSX.Element {
  return (
    <TrialModalContext.Consumer>
      {(toggleModal) => (
        <LazyTooltip tooltip={gt('Register for a trial to test the whole app')}>
          <a
            {...other}
            href="#"
            onClick={(e) => {
              e.preventDefault();
              toggleModal();
            }}
          >
            {children}
          </a>
        </LazyTooltip>
      )}
    </TrialModalContext.Consumer>
  );
}
export const FullHTMLLink = DemoFullHTMLLink;

export const ReplaceableLink = DemoFullHTMLLink;
